/***
 * 描述：点击头像 切换用户模态框
 */
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwRouteguardService } from 'src/app/librarys/serves/sw-routeguard.service';
import { SwSimpleReuseStrategy } from 'src/app/librarys/serves/sw-simplereusestrategy';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import {Md5} from "ts-md5";
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';

@Component({
  selector: 'app-sw-switch-user',
  templateUrl: './sw-switch-user.component.html',
  styleUrls: ['./sw-switch-user.component.css']
})
export class SwSwitchUserComponent implements OnInit {
  @ViewChild('switchUserModal') switchUserModal: SwModalframeComponent;
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  invalid: boolean = false; //判断表单保存是否符合条件
  constructor(
    private _http: SwHttpClientService,
    private user: GetUserModelService,
    private Jwt: SwJwtService,
    private SwMenus: SwMenuService,
    private box :SwMassageBoxService,
    private SwRouter: SwRouteguardService,
    private systemId: SystemIdService,
    private swMaskService:SwMaskService,  //遮罩层服务
  ) { }
  msg: string = "";
  userModel: any = {};
  loginModel: any = {};
  systemData:any=[];
  multiTenancy:boolean; //是否开启多租户管理模式
  ngOnInit() {
    this.userModel = this.user.getUser()
    //this.loginModel.loginName = this.userModel.loginName
    //获取当前登录系统默认值
    let systemId = this.systemId.getSystemId()
    this.loginModel.systemCode = '';
    this.userModel.systems.forEach(element => {
      if(element.systemId == systemId) {
        this.loginModel.systemCode = element.systemCode
      }
    });
    this.multiTenancy = environment.multiTenancy
    this.getSystemData()
  }

  getSystemData(){
    this.systemData = []
    //请求数据
    this._http.Post( environment.seekerWebAPI+"sw/querySystems",{}).subscribe(
      data => {
        if (data["code"] == 200) { 
          data["data"].forEach(val => {
            this.systemData.push({id:val.systemCode,text:val.description})
          });
        }
   
      }
    )
  }

  onSubmit({ value, valid }, event: Event) {
    this.msg = "";
    if (valid) {
      //this._http.Post(`${environment.seekerWebAPI}sw/logout`, null).subscribe(r => { 
        value.systemId = this.systemId.getSystemId()
        let pwd = Md5.hashStr(value.loginPassword);
        this._http.Post(environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + this.loginModel.systemCode, {}).subscribe(
          data => {
            if (data["code"] == 200) {
              // //关闭模态框
              // this.switchUserModal.toggle()
              // //销毁组件
              // this.callback.emit()
              // //立刻打开遮罩层
              // this.swMaskService.openMask('切换用户成功 ，重新加载页面')
              let currlang = this.Jwt.getToken('language')
              this.box.success("切换用户成功 ，重新加载页面")
              this.Jwt.clear(); //清除浏览器缓存数据
              SwSimpleReuseStrategy.deleteAllRouteSnapshot();//清除路由复用
              this.SwRouter.clear(); //清除工作台
              // this.Jwt.setlocaToken("token", data["data"]["jwt"]); //添加新的token
              this.Jwt.setToKen("language",currlang); //登录成功后将当前语言设置存进缓存
              this.Jwt.setToKen("token", data["data"]["jwt"]); //添加新的token
              this.Jwt.removeItem("TabMenu"); //添加新的工作台
              this.Jwt.setToKen("systemId", data["data"]["systemId"]);
              this.SwMenus.location('login');
              setTimeout(() => {
                // this.swMaskService.closeMask()
                window.location.reload();
              }, 5000)
            } else if (data["msg"]) {
              //this.modal.toggle();
              this.msg = data["msg"];
            }
          }
        )
      //})
    }else {
      this.invalid = true;
      this.box.waringError('请输入完整且正确的信息')
    }
  }

  //取消清空输入框和错误信息
  onCancel(){
    this.loginModel.loginName=null;
    this.loginModel.loginPassword=null;
    this.msg='';
    //关闭模态框
    this.switchUserModal.toggle()
    //销毁组件
    this.callback.emit()
  }

}
